// test629
(629 && 0);
